/**
 * «Сохрани прогресс»: анонимный аккаунт живёт на устройстве — сменил
 * телефон или почистил браузер, и уроки пропали. После первого урока
 * предлагаем войти по почте; вход переносит прогресс в аккаунт.
 */

import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Button } from '../Button';
import { IconCloudUpload } from '../icons';

export function SaveProgressCard() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <motion.section
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      aria-label={t('saveProgress.title')}
      className="glass flex flex-col gap-4 rounded-card border border-teal/40 p-5 shadow-card sm:flex-row sm:items-center sm:p-6"
    >
      <span className="grid h-14 w-14 shrink-0 place-items-center rounded-2xl bg-teal/15 text-teal-deep dark:text-teal">
        <IconCloudUpload size={28} stroke={1.8} aria-hidden="true" />
      </span>
      <div className="flex min-w-0 flex-1 flex-col gap-1">
        <h2 className="t-h2">{t('saveProgress.title')}</h2>
        <p className="text-muted">{t('saveProgress.text')}</p>
      </div>
      <Button variant="secondary" onClick={() => navigate('/login')}>
        {t('saveProgress.go')}
      </Button>
    </motion.section>
  );
}
